export default __webpack_public_path__ + "static/media/Bill Huizenga.b5651aa6.jpg";